import { render, staticRenderFns } from "./BtDashboardSave.vue?vue&type=template&id=16269d0e&scoped=true&"
import script from "./BtDashboardSave.vue?vue&type=script&lang=js&"
export * from "./BtDashboardSave.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardSave.vue?vue&type=style&index=0&id=16269d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16269d0e",
  null
  
)

export default component.exports